import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { GetInternPopularBody } from "./_types"

const PATH = "/intern/popular"

export const fetchGetInternPopular = defineFetcher((): Promise<Array<GetInternPopularBody>> => {
  return GET(PATH)
})
